import React from "react";
import Icon from "./Icon";
import "./FeatureHeader.css";

// Centered page header on the plain page background: a small pill badge,
// a large extra-bold olive title and an intro paragraph. Used by Busy Bees,
// Request support and Donate.
export default function FeatureHeader({ badge, icon = "sparkles", title, children }) {
  return (
    <section className="feature-header">
      <div className="container">
        {badge && (
          <span className="feature-badge">
            <Icon name={icon} size={18} />
            {badge}
          </span>
        )}
        <h1>{title}</h1>
        {children && <p>{children}</p>}
      </div>
    </section>
  );
}
